<script lang="typescript">
    import config from "../config"

    import { jsonForOverlay } from "../store"

    export let close: Function
    export let items: SyncEntry[]
</script>

<div class="background">
    <div class="content">
        <h4>Queue</h4>
        <table cellspacing="0" cellpadding="0">
            <tr>
                <th>Item</th>
                <th>ID</th>
                <th>Name</th>
            </tr>
            {#each items as i}
                <tr
                    class="{i.obj.method}"
                    on:click="{() => {
                        $jsonForOverlay = [i.obj.xlsRow, i.obj.online, i.obj.diff]
                    }}"
                >
                    <td><i>{i.collection}</i></td>
                    <td>{i.obj.id}</td>
                    <td>{i.obj.name && i.obj.name[config.defaultLanguage]}</td>
                </tr>
            {/each}
        </table>
    </div>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
        class="close"
        on:click="{() => {
            close()
        }}"
    >
        X
    </div>
</div>

<style lang="less">
    .background {
        left: 50px;
        right: 50px;
        top: 50px;
        bottom: 50px;
        position: fixed;
        background-color: #00000070;
        z-index: 100;
    }

    div.close {
        color: white;
        position: fixed;
        right: 30px;
        top: 30px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border: 1px solid white;
        border-radius: 5px;
        text-align: center;
        background: black;
        cursor: pointer;
    }

    .background div.content {
        position: fixed;
        top: 50px;
        left: 50px;
        bottom: 50px;
        right: 50px;
        margin: auto;
        color: black;
        background-color: #ffffff;
        padding: 20px;
        overflow: auto;
        line-height: 1.2em;
        border: 2px outset #999;
    }

    .delete {
        color: darkred;
        text-decoration: line-through;
    }
    .put {
        color: darkorange;
    }
    .post {
        color: darkgreen;
    }
    th {
        text-align: left;
        padding: 5px;
    }
    td {
        padding: 5px;
    }
    tr:nth-child(odd) td {
        background: #eee;
    }
    tr:hover td {
        font-weight: bold;
        cursor: pointer;
    }
</style>
